export class ARByDos {
  doS: string;
  amountDue: number;
  arAge: string;
  arBucket: string;
  patientDetailsList: PatientDetailsList[] = [];
}
export class PatientDetailsList {
  patientId: number;
  patientName: string;
  amountDue: number;
  provider: string;
}
export class ARByPatient {
  patientId: number;
  patientName: string;
  amountDue: number;
  provider: string;
  arAge: string;
  arBucket: string;
}

export class ARByPayor {
  payorId: number;
  payor: string;
  amountDue: number;
}

export class ARByPayorDetails {
  patientId: number;
  subscriberId: number;
  patientName: string;
  doS: string;
  insPortionEstimate: number;
  insPaidAmount: number;
  insDueAmount: number;
  arAge: number;
  arBucket: string;
  claimSubmittedDate: string;
  claimStatus: string;
}

export class ARByPayorByIdResp {
  payor: string;
  totalDueAmount: number;
  arByPayorByIdList: ARByPayorDetails[] = [];
  totalRecords: number;
}

export class ARTargetList {
  id?: number;
  targetListsId: number;
  filterName: string = '';
  description: string;
  targetedPatient: number;
  targetedAmount: number;
  createdOn: string;
  link?: string;
}

export class TargetListsDetails {
  patientId: number;
  patientName: string;
  amount: number;
  provider: string;
}

export class TargetListFilter {
  id?: number;
  filterName: string;
  description: string;
  type: number;
  amountFilter: number;
  amount: number;
  providerFilter: number;
  providerId: any;
  payorFilter: number;
  payorId: any;
  arBucketFilter: number;
  arBucket: any;
  claimStatusFilter: number;
  claimStatus: any;
  practiceId: number;
}

export class ARListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
  payorId?: number = 0;
  targetListsId?: number = 0;
}

export class PatientARListReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
  id: number = 0;
}

export class ARByDosResp {
  arByDOSList: ARByDos[];
  totalRecords: number = 0;
}

export class ARByPatientResp {
  arByPatientList: ARByPatient[];
  totalRecords: number = 0;
}

export class ARByPayorResp {
  arByPayorList: ARByPayor[];
  totalRecords: number = 0;
}

export class ARTargetListResp {
  arTargetsList: ARTargetList[];
  totalRecords: number = 0;
}

export class TargetListsDetailsResp {
  arByTargetPatientList: TargetListsDetails[];
  arTargetDetail: ARTargetList;
  totalRecords: number = 0;
}

export class CampaignListResp {
  campaigns: Campaign[];
  totalRecords: number = 0;
}

export class CampaignResp {
  campaign: Campaign;
  schedules: Schedule[];
}

export class Schedule {
  campaignId: number;
  communicationType: number;
  discount: number;
  discountType: number;
  emailTemplateId: number;
  executionDate: string;
  id: number;
  paymentPromotion: boolean;
  practiceId: number;
  rowNumber: number;
  smsTemplateId: number;
  targetListId: number;
  totalRecords: number;
}

export class CampaignListReq {
  practiceId: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
}

export class Campaign {
  campaignId: number;
  campaignTemplateId: number;
  templateName: string;
  practiceId: number;
  targetListId: number;
  campaignName: string;
  frequency: string;
  frequencyDay: number;
  frequencyWeek: number;
  smsTemplateId: number;
  emailTemplateId: number;
  createDate?: string;
  startDate: string;
  endDate: string;
  communicationType: number;
  paymentPromotion: boolean;
  discount: number;
  discountType: number;
  previewOnly?: boolean;
  isActive: boolean;
  description?: string;
  patientCount: number;
  totalAmount: number;
  uniquePatientCount?: number = 0;
  totalCollectedAmount?: number = 0;
  hasPaidPatients?: boolean = false;
}

export class CampaignTemplate {
  id: number = 0;
  srno?: number = 0;
  practiceId: number;
  targetListId: number;
  templateName: string;
  frequency: string;
  duration: number;
  frequencyDay: number;
  frequencyWeek: number;
  emailTemplateId: number;
  smsTemplateId: number;
  isActive: boolean;
  description: string;
  communicationType: number;
}

export class CampaignTemplateListResp {
  campaignTemplateViews: CampaignTemplate[];
  totalRecords: number = 0;
}

export class CampaignTemplateDropdown {
  id: number;
  templateName: string;
}

export class CampaignTemplateReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
}

export class SMSTemplate {
  id?: number = 0;
  srno?: number = 0;
  templateName: string;
  templateBody: string;
  practiceId: number = 0;
  isActive: boolean = true;
  createdBy?: string;
  updatedBy?: string;
  createdOn?: string;
  updatedOn?: string;
  templateType: number;
  moduleId: number;
  description?: string;
  activeCampaigns?: number = 0;
}

export class SMSTemplateListResp {
  smsTemplateViews: SMSTemplate[] = [];
  totalRecords: number = 0;
}

export class SMSTemplateReq {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
}

export class SmsTemplateDropdownResp {
  templateName: string;
  id: number ;
}
export class CampaignPaidPatientsRequest {
  practiceId: number = 0;
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = 'PatientId';
  pageNumber: number = 1;
  pageSize: number = 15;
}

export class CampaignPaidPatients {
  patientId: number;
  patientName: string;
  amount: number;
  provider: string;
}

export class CampaignPaidPatientsListResponse {
  paidPatientsList: CampaignPaidPatients[];
  totalRecords: number;
}